import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { Globals } from '../services/globals';
@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.css']
})
export class ErrorComponent implements OnInit {
  messages: string;
  subscription: Subscription;
  constructor(private router: Router,
    public globals: Globals,
    ) {
  }

  ngOnInit(): void {
    this.messages = sessionStorage.getItem("errorMessage");
    this.globals.hasBackgroundHeaderImage = false;
  }
  goToLogin() {
    this.router.navigate(['/login']);
    
  }

}
